import React from 'react';
import {
  Box, Link,
  Typography,
} from '@material-ui/core';
import { Account } from 'src/types';
import { Link as RouterLink } from 'react-router-dom';
import StackAvatars from '../StackAvatars';

const UserCell = ({ accounts }: { accounts: Account[] }) => (
  <Box
    display="flex"
    alignItems="center"
  >
    <StackAvatars
      avatars={accounts}
      limit={3}
    />
    <div>
      <Typography variant="h6">
        {accounts.filter((account) => account.firstName && account.lastName).map((account: any) => (
          <Link
            key={account.id}
            variant="h6"
            color="inherit"
            to={`/contacts/${account.id}`}
            component={RouterLink}
          >
            {`${account.firstName} ${account.lastName}`}
          </Link>
        ))}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        {accounts.filter((bp: any) => bp.email).map((bp: any) => bp.email).join(', ')}
      </Typography>
    </div>
  </Box>
);

export default UserCell;
